import { createSelector } from '@reduxjs/toolkit';

const selectSelf = (state) => state;

export const selectCurrentAccount = createSelector(selectSelf, (state) => {
  return state.UACReducers?.MALR?.ManagedAccounts?.find(({ IsActive }) => IsActive) ?? null;
});
